import { Link, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { Book, Code, Hash, Database, List } from 'lucide-react';

const navItems = [
  { label: 'Guides', href: '/docs/guides', icon: Book },
  { label: 'API', href: '/docs/api', icon: Code },
  { label: 'Data Types', href: '/docs/data-types', icon: Hash },
  { label: 'Field Library', href: '/docs/field-library', icon: Database },
  { label: 'Lookups', href: '/docs/lookups', icon: List },
];

interface DocsNavProps {
  className?: string;
}

export function DocsNav({ className }: DocsNavProps) {
  const location = useLocation();
  
  const isActive = (href: string) => {
    // Special case for hub page
    if (location.pathname === '/docs') return false;
    if (href === '/docs/guides') {
      return location.pathname === '/docs/guides' || location.pathname.startsWith('/docs/guides/');
    }
    return location.pathname === href || location.pathname.startsWith(href + '/');
  };
  
  return (
    <nav className={cn(
      'sticky top-14 z-40 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60',
      className
    )}>
      <div className="container flex items-center h-12">
        <div className="flex items-center gap-1">
          {navItems.map((item) => {
            const Icon = item.icon;
            const active = isActive(item.href);
            return (
              <Link
                key={item.href}
                to={item.href}
                className={cn(
                  'flex items-center gap-2 px-3 py-2 text-sm font-medium rounded-md transition-colors',
                  active
                    ? 'bg-primary/10 text-primary'
                    : 'text-muted-foreground hover:text-foreground hover:bg-muted'
                )}
              >
                <Icon className="h-4 w-4" />
                <span className="hidden sm:inline">{item.label}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
